import { ProgressStepModel } from "./progress-step.model";
import { AlertModel } from "./alert.model";

export const IActionCardsProperties = Object.freeze({
  url: "url",
  picto: "picto",
  title: "title",
  description: "description",
  alert: "alert",
  step: "step",
});

export class ActionCardsPropertiesModel {
  constructor(data = {}) {
    this[IActionCardsProperties.picto] = data[IActionCardsProperties.picto];
    this[IActionCardsProperties.title] = data[IActionCardsProperties.title];
    this[IActionCardsProperties.url] = data[IActionCardsProperties.url];
    this[IActionCardsProperties.description] = data[IActionCardsProperties.description];
    this[IActionCardsProperties.alert] = data[IActionCardsProperties.alert];
    this[IActionCardsProperties.step] = data[IActionCardsProperties.step];
  }

  getPicto() {
    return this[IActionCardsProperties.picto];
  }

  getTitle() {
    return this[IActionCardsProperties.title];
  }
  getUrl() {
    return this[IActionCardsProperties.url];
  }
  getDescription() {
    return this[IActionCardsProperties.description];
  }
  getAlert() {
    return new AlertModel(this[IActionCardsProperties.alert]);
  }
  getStep() {
    return new ProgressStepModel(this[IActionCardsProperties.step]);
  }
}
